import { ORDER_MONEY_PAY_TYPE } from '@/config'

export function getOrderMoneyPayType(order) {
  const { orderState, refundState, isPayPeriod, payPeriodInfo } = order
  if (
    orderState === 10 &&
    (refundState === 10 || refundState === 40) &&
    +isPayPeriod === 1 &&
    payPeriodInfo
  ) {
    const { prePayOrder, endPayOrder } = payPeriodInfo
    // / preOrderState 定金单状态 10待支付 20待核销 30待评价 40已完成 50已取消 70已过期
    if (prePayOrder && +prePayOrder.preOrderState === 10) {
      return ORDER_MONEY_PAY_TYPE.prePayOrder
      // endOrderState 尾款单状态 10待支付 20待核销 30待评价 40已完成 50已取消 70已过期
    } else if (endPayOrder && +endPayOrder.endOrderState === 10) {
      return ORDER_MONEY_PAY_TYPE.endPayOrder
      // 分布订单支付完成
    } else if (
      prePayOrder &&
      +prePayOrder.preOrderState === 40 &&
      endPayOrder &&
      +endPayOrder.endOrderState === 40
    ) {
      return ORDER_MONEY_PAY_TYPE.stepOrderFinished
    }
  }
  return ORDER_MONEY_PAY_TYPE.commonGood
}
